//+-------------------------------------------------
// Node Modules Import
//+-------------------------------------------------
// import gsap from 'gsap';
// import ScrollTrigger from 'gsap/ScrollTrigger';

//gsap.registerPlugin(ScrollTrigger);

//+-------------------------------------------------
// gsapScrollTriggerAnimation()
// Trigger animations individually for each
// data-gsapst child depending on attribute
//+-------------------------------------------------
function gsapScrollTriggerAnimation() {
  //    let gsapstAnimationEle = gsap.utils.toArray($('[data-gsapst-animation]'));
  const datagsapstAnimation = document.querySelectorAll('[data-gsapst-animation]');
  let gsapstAnimations = gsap.utils.toArray(datagsapstAnimation);
  // Animation Loop
  gsapstAnimations.forEach((gsapstAnimationEle) => {
    //        const gsapstTrigger = $(gsapstAnimationEle).closest('[data-gsapst-trigger]');
    // convert above line to vanilla js
    const gsapstTrigger = gsapstAnimationEle.closest('[data-gsapst-trigger]');
    let gsapstTriggerStart = 'top 75%';
    let gsapstTriggerEnd = 'top 75%';
    let gsapstTriggerScrub = false;
    //        const gsapstDirection = $(gsapstAnimationEle).data('gsapst-animation');
    // convert above line to vanilla js
    //gsapstAnimationEle is "<div data-gsapst-animation="fadein-down" class="">...</div>"
    // get data attribute data-gsapst-animation from gsapstAnimationEle object
    const gsapstDirection = gsapstAnimationEle.dataset.gsapstAnimation;
    let gsapstSettings;
    let gsapstDurationSetting;
    let gsapstDelaySetting;
    let gsapstStagger;

    // Trigger
    // +-----------------------------------------------------------------------------
    // Defining all available trigger settings:
    // - Trigger Start/End (with same value)
    // - Trigger Start
    // - Trigger End
    // - Trigger Scrub
    // +-----------------------------------------------------------------------------
    //        if( gsapstTrigger.data('gsapst-trigger') !== '' ) {
    // vanila js conversion of directly above
    if (typeof gsapstTrigger.dataset.gsapstTrigger !== 'undefined' && gsapstTrigger.dataset.gsapstTrigger !== '') {
      //            gsapstTriggerStart = gsapstTriggerEnd = gsapstTrigger.data('gsapst-trigger');
      console.log('gsapstTrigger:', gsapstTrigger);
      gsapstTriggerStart = gsapstTriggerEnd = gsapstTrigger.dataset['gsapst-trigger'];
    }
    //        if( gsapstTrigger.is('[data-gsapst-trigger-start]') ) {\
    // convert above line to vanilla js
    // if gsapstTrigger has data-gsapst-trigger-start attribute
    if (
      typeof gsapstTrigger.dataset.gsapstTriggerStart !== 'undefined' &&
      gsapstTrigger.dataset.gsapstTriggerStart !== ''
    ) {
      if (gsapstTrigger.dataset['gsapst-trigger-start'] !== '') {
        gsapstTriggerStart = gsapstTrigger.dataset['gsapst-trigger-start'];
      }
    }
    if (
      typeof gsapstTrigger.dataset.gsapstTriggerEnd !== 'undefined' &&
      gsapstTrigger.dataset.gsapstTriggerEnd !== ''
    ) {
      if (gsapstTrigger.dataset['gsapst-trigger-end'] !== '') {
        gsapstTriggerEnd = gsapstTrigger.dataset['gsapst-trigger-end'];
      }
    }
    if (
      typeof gsapstTrigger.dataset.gsapstTriggerScrub !== 'undefined' &&
      gsapstTrigger.dataset.gsapstTriggerScrub !== ''
    ) {
      if (gsapstTrigger.dataset['gsapst-trigger-scrub'] !== '') {
        gsapstTriggerScrub = gsapstTrigger.dataset['gsapst-trigger-scrub'];
      }
    }

    // Default Tweens
    if (gsapstDirection === 'fadein') {
      gsapstSettingsFrom = { opacity: 0 };
      gsapstSettingsTo = { opacity: 1 };
    }
    if (gsapstDirection === 'fadein-up') {
      gsapstSettingsFrom = { y: 50, opacity: 0 };
      gsapstSettingsTo = { y: 0, opacity: 1 };
    }
    if (gsapstDirection === 'fadein-right') {
      gsapstSettingsFrom = { x: 50, opacity: 0 };
      gsapstSettingsTo = { x: 0, opacity: 1 };
    }
    if (gsapstDirection === 'fadein-down') {
      gsapstSettingsFrom = { y: -50, opacity: 0 };
      gsapstSettingsTo = { y: 0, opacity: 1 };
    }
    if (gsapstDirection === 'fadein-left') {
      gsapstSettingsFrom = { x: -50, opacity: 0 };
      gsapstSettingsTo = { x: 0, opacity: 1 };
    }

    // Custom Tweens
    // +-----------------------------------------------------------------------------
    // You can name your tween as you want and add tween custom settings
    // Feel free to create as many custom tweens as you need duplicating this example
    // +-----------------------------------------------------------------------------
    if (gsapstDirection === 'custom') {
      gsapstSettings = {
        /* Your custom tween settings here */
      };
    }

    // Duration Settings
    //        if( $(gsapstAnimationEle).is('[data-gsapst-duration]') ) {
    if (
      typeof gsapstAnimationEle.dataset.gsapstDuration !== 'undefined' &&
      gsapstAnimationEle.dataset.gsapstDuration !== ''
    ) {
      const gsapstDuration = gsapstAnimationEle.dataset['gsapst-duration'];
      gsapstDurationSetting = { duration: gsapstDuration };
    } else {
      gsapstDurationSetting = { duration: 0.75 };
    }

    // Delay Settings
    //        if( $(gsapstAnimationEle).is('[data-gsapst-delay]') ) {
    if (
      typeof gsapstAnimationEle.dataset.gsapstDelay !== 'undefined' &&
      gsapstAnimationEle.dataset.gsapstDelay !== ''
    ) {
      const gsapstDelay = gsapstAnimationEle.dataset['gsapst-delay'];
      gsapstDelaySetting = { delay: gsapstDelay };
    } else {
      gsapstDelaySetting = { delay: 0 };
    }

    // Stagger Settings
    //        if( $(gsapstAnimationEle).is('[data-gsapst-stagger]') ) {
    // if (gsapstAnimationEle.dataset['data-gsapst-stagger'] is not undefined or empty)
    if (
      typeof gsapstAnimationEle.dataset.gsapstStagger !== 'undefined' &&
      gsapstAnimationEle.dataset.gsapstStagger !== ''
    ) {
      const gsapstStaggerTarget = gsapstAnimationEle.dataset['gsapst-stagger'];
      let gsapstStaggerEach = null;
      const gsapstStaggerElement = gsapstAnimationEle.querySelectorAll(gsapstStaggerTarget);

      //            if($(gsapstAnimationEle).is('[data-gsapst-stagger-each]')) {
      if (gsapstAnimationEle.dataset['data-gsapst-stagger-each'] !== '') {
        gsapstStaggerEach = gsapstAnimationEle.dataset['gsapst-stagger-each'];
      } else {
        gsapstStaggerEach = 0.3;
      }
      console.log('gsapstStaggerElement:', gsapstStaggerElement);
      gsapstAnimationEle = gsapstStaggerElement;

      gsapstStagger = {
        stagger: {
          each: gsapstStaggerEach,
        },
      };
    } else {
      gsapstStagger = {};
    }
    console.log(
      gsapstAnimationEle,
      gsapstSettings,
      gsapstDurationSetting,
      gsapstDelaySetting,
      gsapstStagger,
      gsapstTrigger,
      gsapstTriggerStart,
      gsapstTriggerEnd,
      gsapstTriggerScrub
    );

    gsap.set(gsapstAnimationEle, gsapstSettingsFrom);

    gsap.to(gsapstAnimationEle, {
      ...gsapstSettingsTo,
      ...gsapstDurationSetting,
      ...gsapstDelaySetting,
      ...gsapstStagger,
      scrollTrigger: {
        trigger: gsapstTrigger,
        start: gsapstTriggerStart,
        end: gsapstTriggerEnd,
        markers: false,
        scrub: gsapstTriggerScrub,
        toggleActions: 'play none none reverse',
      },
    });
    /*
    // Main Tween
    gsap.from(
      '[data-gsapst-animation]',
      Object.assign(
        {},
        gsapstSettings, // Load tween settings
        gsapstDurationSetting, // Load duration setting if exists
        gsapstDelaySetting, // Load delay setting if exists
        gsapstStagger, // Load stagger setting if exists and change animation target
        {
          scrollTrigger: {
            // markers: true,
            trigger: gsapstTrigger,
            start: gsapstTriggerStart,
            end: gsapstTriggerEnd,
            scrub: gsapstTriggerScrub,
          },
        }
      )
    );
    */
  });
}
function scrollTriggerAnimations() {
  window.setTimeout(() => {
    // Stop execution when no swiper element has been found
    //if ($('[data-gsapst-animation]').length === 0) {
    // vanila js conversion of above line
    if (document.querySelectorAll('[data-gsapst-animation]').length === 0) {
      return;
    }
    console.log('gsapScrollTriggerAnimation()');
    // Initialize execution if any data-gsapst-animation has been found
    gsapScrollTriggerAnimation();
  }, 300);
}

// -- Initial execution
// Runs selected functions on jQuery window.ready
//+--------------------------------
//$(function() {
//   scrollTriggerAnimations();
//});

// fire scrollTriggerAnimations() when dom is loaded
document.addEventListener('DOMContentLoaded', scrollTriggerAnimations);
